import {FormProvider, useForm, useFormContext} from "react-hook-form";
import React from "react";
import {FormGroup, SubmitButton} from "../../../../@coherent/react-hook-form";
import { TextQuestion } from "../../components/TextQuestion";
import { Button } from "reactstrap";

const referenceByIndexQuestions = {
  1: {
    options: [
      'Current Church Leader',
      'Current Church Elder/Deacon/Home Group Leader',
      'Member of Church Leadership Team'
    ]
  },
  2: {
    options: [
      'Current Employer or colleague',
      'Former Employer or colleague',
      "In a supervisory role in a volunteer position (e.g. youth or children's worker, supervisor of messy church, food bank etc.)",
      "Alongside them in a voluntary position (e.g. youth or children's worker, supervisor of messy church, food bank etc.)",
      "Known in a personal capacity (I am not a family member)"
    ]
  },
  3: {
    options: [
      "Former Church Leader",
      "Former Church Elder/Deacon/Home Group Leader",
      "Member of Former Church Leadership Team"
    ]
  }
}

export const Step2Form = ({ required = true, defaultValues }) => {
  const { reference_number, relationship } = defaultValues;
  const referenceNumberQuestion = referenceByIndexQuestions[reference_number];
  const { register } = useFormContext();

  return (
    <>
      <h3 className="tw-text-lg mb-4">Questions regarding how you know the applicant</h3>
      <p>
        Please note, we request that referees have known the applicant for at least 2 years and should be a employer/former employer/someone who has known them in a volunteer capacity. We do not accept any references from family members and you should state in what capacity you have known them as per the above and not just as a 'friend'.
      </p>
      <hr/>
      <TextQuestion name="applicant_name" label="Name of the Applicant" required={required} />
      {referenceNumberQuestion ? (
        <FormGroup
          name="relationship"
          label="In what capacity do you know the applicant"
          required
        >
          <select ref={register({ required: true })} className="form-control" name="relationship">
            {relationship && !referenceNumberQuestion.options.includes(relationship) && (
              <option value={relationship}>{relationship}</option>
            )}
            {referenceNumberQuestion.options.map((option, index) => (
              <option key={index} value={option}>{option}</option>
            ))}
          </select>
        </FormGroup>
      ) : (
        <TextQuestion
          name="relationship"
          label="In what capacity do you know the applicant"
          required={required}
        />
      )}
      <TextQuestion name="years_known" label="How long have you known the applicant" required={required} />
    </>
  );
};

export const Step2 = ({ onSubmit, defaultValues, onBack }) => {
  const methods = useForm({
    mode: "onBlur",
    defaultValues,
    shouldUnregister: true,
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Step2Form defaultValues={defaultValues} />
        <div className="tw-flex tw-justify-between">
          <Button onClick={onBack}>Back</Button>
          <SubmitButton>Continue</SubmitButton>
        </div>
      </form>
    </FormProvider>
  );
};
